import { environment, variablesGlobales } from "../../configs/variables";
import { APIClient } from "../../helpers/api_helper";
import { SUBSCRIBE_USER_WEB_PUSH } from "../../helpers/url_helper";

const apiClient = new APIClient();

// Función para convertir la clave pública VAPID
export const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    return outputArray;
};


export const registerServiceWorker = async () => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
        try {
            // Registrar el Service Worker
            let registration = await navigator.serviceWorker.register('../../service-worker.js');
            if (environment !== 'PROD') console.log('Service Worker Registered.');

            return registration;
        } catch (error) {
            console.error('Error al registrar el Service Worker:', error);
            return null;
        }
    }
};

export const requestPermissionNotification = async () => {
    try {
        // Pedir permiso para mostrar notificaciones
        let permission = await Notification.requestPermission();
        return permission === 'granted';
    } catch (error) {
        console.error(error);
        return false;
    }

};

export const subscribeUser = async (registration, userId) => {
    const subscribeOptions = {
        userVisibleOnly: true,
        applicationServerKey: variablesGlobales.vapidKey
    };

    const subscription = await registration.pushManager.subscribe(subscribeOptions);
    if (environment !== 'PROD') console.log('User is subscribed.');

    await apiClient.create(SUBSCRIBE_USER_WEB_PUSH + "/" + userId, subscription);

};


